import { render } from "./WArticulosMasComprados.vue?vue&type=template&id=c81c6b90"
import script from "./WArticulosMasComprados.vue?vue&type=script&lang=js"
export * from "./WArticulosMasComprados.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__